import React, { useMemo } from 'react';
import ActionsModal from '../ActionsModal/ActionsModal.js';
import { cancelButtonConfig, deleteButtonConfig } from '../config.js';
import { useCustomTranslation } from '../../../Hooks/useCustomTranslation/useCustomTranslation.js';

/**
 * @deprecated In favor of the new Modal of the BCL, see (https://nearpod-packages.gitlab-pages.nearpod.com/base-component-library/?path=/docs/library-modal--docs)
 */
const DeleteModal = _ref => {
  let {
    isOpen = false,
    closeButton = false,
    deleteButton,
    cancelButton,
    title,
    description,
    closeModal
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  const newActionButtonsProps = useMemo(() => [{
    ...cancelButtonConfig,
    children: cancelButton.children || tCustom('CANCEL'),
    onClick: cancelButton.onCancel
  }, {
    ...deleteButtonConfig,
    children: deleteButton.children || tCustom('DELETE'),
    onClick: deleteButton.onDelete
  }], [cancelButton.children, cancelButton.onCancel, deleteButton.children, deleteButton.onDelete, tCustom]);
  const newActionModalProps = {
    isOpen,
    closeButton,
    actionButtons: newActionButtonsProps,
    title,
    description,
    closeModal
  };
  return /*#__PURE__*/React.createElement(ActionsModal, newActionModalProps);
};
var DeleteModal$1 = DeleteModal;

export { DeleteModal$1 as default };
//# sourceMappingURL=DeleteModal.js.map
